import { render, staticRenderFns } from "./SubmitWorkerAction.vue?vue&type=template&id=cfbe0cb8&scoped=true&"
import script from "./SubmitWorkerAction.vue?vue&type=script&lang=js&"
export * from "./SubmitWorkerAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbe0cb8",
  null
  
)

export default component.exports